import React, {Component} from 'react';
import Select from "../../../local_node_modules/react-select"
import '../../../local_node_modules/react-select/dist/react-select.css';
import Alert from 'react-s-alert';
import Swal from 'sweetalert2';
import {Decimal} from 'decimal.js';
import NumberFormat from 'react-number-format';
import {deepCopyObject, getStocks, showAxiosError} from "../../../helper/helper";
import {validateField} from "../../../common/validation";
import {UncontrolledTooltip} from 'reactstrap';
import {filterOptions} from "../../../helper/invoiceHelper";
import StockModal from "../../stock/StockModal";
import DespatchLineModal from "./DespatchLineModal";
import XLSX from "xlsx";
import {DespatchLineEnum} from "../../../helper/enums";
import moment from "moment";
import {request} from "../../../helper/APIUtils";

class DespatchLines extends Component {
	constructor(props) {
		super(props);
		this.state = {
			despatchLines: [],
			stockModal: false,
			despatchLineModal: false,
			index: 0,
		};
		this.addDespatchLine = this.addDespatchLine.bind(this);
		this.removeDespatchLine = this.removeDespatchLine.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onStockChange = this.onStockChange.bind(this);
		this.setStocks = this.setStocks.bind(this);
		this.onValueChange = this.onValueChange.bind(this);
		this.validateField = this.validateField.bind(this);
		this.editDespatchLine = this.editDespatchLine.bind(this);
		this.setDespatchLine = this.setDespatchLine.bind(this);
		this.handleUploadExcel= this.handleUploadExcel.bind(this);
		this.bulkFileSelected = this.bulkFileSelected.bind(this);
		this.validateRowData = this.validateRowData.bind(this);
		this.rowToDespatchLine = this.rowToDespatchLine.bind(this);
		this.exportToExcel = this.exportToExcel.bind(this);
		this.exportStockToExcelUnits = this.exportStockToExcelUnits.bind(this);
		this.checkUnit = this.checkUnit.bind(this);
		this.inputFile = React.createRef();
		this.onInputChange = this.onInputChange.bind(this);
		this.onInputKeyDown = this.onInputKeyDown.bind(this);
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		if (id.includes("kunyeNo"))
			rule = "kunyeNo";
		let result = validateField(rule, boundary, e.target.value);
		let error = this.props.error;
		error = Object.assign(error, {[id]: result});
		this.props.errorListener(error);
	}

	validateClass(id) {
		let error = this.props.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.props.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	componentWillMount() {
		let despatchLines = deepCopyObject(this.props.despatchLines);

		this.setState({
			despatchLines: despatchLines,
			unitCodes: this.props.unitCodes,
		});
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.despatchLines !== nextProps.despatchLines) {
			this.setState({despatchLines: nextProps.despatchLines});
		}

		if (nextProps.manual) {
			this.setState({despatchLines: nextProps.despatchLines,error:{}});
			this.props.isManual(false);
			this.props.errorListener({});
		}
	}

	static calculate(despatchLine) {
		let tempQuantity = despatchLine.quantity === "" ? 1: despatchLine.quantity;
		let tempUnitPrice = despatchLine.unitPrice === "" ? 0 : despatchLine.unitPrice;

		let baseTaxableAmount = new Decimal(tempQuantity).mul(new Decimal(tempUnitPrice));
		despatchLine.lineExtensionAmount = new Decimal(baseTaxableAmount.toFixed(2)).toNumber();
		return despatchLine;
	}

	onStockChange(data, index) {
		let self = this;
		if (data !== null) {
			if (data.hasOwnProperty("stock")) {
				let despatchLines = deepCopyObject(self.state.despatchLines);
				let stock = data.stock;
				if (stock.defaultCurrencyCode === self.props.documentCurrencyCode) {
					despatchLines = self.setStock(stock, despatchLines, index, self.props.direction, true);
					self.props.listener(despatchLines);
					self.setState({despatchLines});
				} else {
					Swal({
						title: 'Yine de uygulansın mı?',
						html: 'Seçmeye çalıştığınız <strong style="font-weight: bold;">Stok Para Birimi(' + stock.defaultCurrencyCode + ')</strong> ile <strong style="font-weight: bold;">Doküman Para Birimi(' + self.props.documentCurrencyCode + ')</strong> uyuşmuyor.',
						showCancelButton: true,
						confirmButtonText: 'Tamam',
						cancelButtonText: 'İptal',
						showCloseButton: true,
					}).then((result) => {
						if (result.value) {
							despatchLines = self.setStock(stock, despatchLines, index, self.props.direction, false);
							self.props.listener(despatchLines);
							self.setState({despatchLines});
						}
					});
				}
			}
		}
	}

	setStock(stock, trdDocVoucherLines, index, direction, setUnitPrice) {
		trdDocVoucherLines[index]["itemCode"] = stock.code;
		trdDocVoucherLines[index]["itemName"] = stock.name;
		trdDocVoucherLines[index]["unit"] = stock.baseUnit;
		trdDocVoucherLines[index]["unitPrice"] = setUnitPrice ? (new Decimal(this.props.direction === "despatchInboxes" ? stock.defPricePurchase : stock.defPriceSell).toNumber()) : 0.00;
		trdDocVoucherLines[index] = DespatchLines.calculate(trdDocVoucherLines[index]);
		return trdDocVoucherLines;
	}

	createStock(option, index) {
		let stock = {
			alias: "",
			applyQuantityControl: 1,
			baseUnit: "C62",
			code: "",
			defPricePurchase: 0,
			defPriceSell: 0,
			defaultCurrencyCode: this.props.documentCurrencyCode,
			explanation: "",
			itemType: {recordId: 1, itemName: "MAL"},
			kdvPurchase: 1,
			kdvSell: 1,
			name: option.value,
			otv: 0,
			recordId: null,
			stockGroup: 1,
		};
		this.setState({stock: stock, stockModal: true, isCreate: false, index: index});
	}

	setStocks(stock, isSetParent) {
		let index = this.state.index;
		if (!isSetParent) {
			this.setState({stockModal: false});
		} else {
			let despatchLines = deepCopyObject(this.state.despatchLines);
			despatchLines[index]["itemCode"] = stock.code;
			despatchLines[index]["itemName"] = stock.name;
			despatchLines[index]["unit"] = stock.baseUnit;
			despatchLines[index]["unitPrice"] = new Decimal(this.props.direction === "despatchInboxes" ? stock.defPricePurchase : stock.defPriceSell).toNumber();
			despatchLines[index] = DespatchLines.calculate(despatchLines[index]);
			this.props.listener(despatchLines);
			this.setState({despatchLines: despatchLines, stockModal: false});
		}
	}

	editDespatchLine(index) {
		let despatchLines = deepCopyObject(this.state.despatchLines);
		let despatchLine = despatchLines[index];
		this.setState({despatchLineModal: true, index: index, despatchLine: despatchLine});
	}

	onChange(e, label, index) {
		let despatchLines = deepCopyObject(this.state.despatchLines);
		despatchLines[index][label] = (label === "unitPrice" || label === "quantity") && (e.target.value === "," || e.target.value === ".")
			? "0."
			: ((label === "quantity" && e.target.value !== "") || (label === "unitPrice" && e.target.value !== ""))
				? (new Decimal(e.target.value)).toNumber()
				: e.target.value;
		//despatchLines[index] = this.calculate(despatchLines[index]);
		this.props.listener(despatchLines);
		this.setState({despatchLines});
	}

	onValueChange(e, label, index) {
		let despatchLines = deepCopyObject(this.state.despatchLines);
		const {value} = e;

		let isQuantityEmpty = false;

		if (label === "quantity") {
			if (value === "") {
				isQuantityEmpty = true;
				despatchLines[index][label] = 1;
			} else {
				despatchLines[index][label] = value;
			}
		} else if (label === "unitPrice") {
			if (value === "") {
				despatchLines[index][label] = "0"
			} else if (value === ".") {
				despatchLines[index][label] = "0.";
			} else {
				despatchLines[index][label] = value;
			}
		} else {
			despatchLines[index][label] = value;
		}

		despatchLines[index] = DespatchLines.calculate(despatchLines[index]);

		if (isQuantityEmpty) {
			despatchLines[index][label] = "";
		}

		this.props.listener(despatchLines);
		this.setState({despatchLines});
	}

	setDespatchLine(despatchLine) {
		let despatchLines = deepCopyObject(this.state.despatchLines);
		despatchLines[this.state.index] = despatchLine;
		this.setState({despatchLineModal: false, despatchLines: despatchLines});
		this.props.listener(despatchLines);
	}

	addDespatchLine() {
		let despatchLines = deepCopyObject(this.state.despatchLines);
		despatchLines.push({
			recordId: null,
			itemCode: null,
			itemId: null,
			itemName: '',
			kunyeNo: null,
			quantity: 1,
			unit: 'C62',
			unitPrice: 0,
			outstandingQuantity: 0,
			outstandingReason: '',
			lineExtensionAmount: 0,
			innerItemCount:0,
		});
		this.props.listener(despatchLines);
		this.setState({despatchLines});
	}

	removeDespatchLine(index) {
		let despatchLines = deepCopyObject(this.state.despatchLines);
		if (despatchLines.length === 1) {
			Alert.success("Belge en az bir satır içermelidir.", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		} else {
			despatchLines.splice(index, 1);
			this.props.listener(despatchLines);
			this.setState({despatchLines: despatchLines});
		}
	}

	arrowRenderer(e){
		let onMouseDown = e.onMouseDown;
		return React.createElement('span', {
			className: 'search',
			onMouseDown: onMouseDown
		});
	}


	handleUploadExcel(e) {
		let self = this;
		let files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
		if (files && files[0]) {
			let type = files[0].type;
			let size = files[0].size;
			let name = files[0].name;
			let allowedExtensions = /(\.xls|\.xlsx|\.csv)$/i;
			if (!allowedExtensions.exec(name)) {
				Alert.error("Dosya formatı uygun değil.(.xls,.xlsx,.csv)", {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 4000,
					html: true
				});
				return;
			}
			let fileReader = new FileReader();
			fileReader.readAsArrayBuffer(files[0]);
			fileReader.onload = () => {
				self.bulkFileSelected(fileReader.result, self);
			};

			e.target.value = null;
		} else {
			Alert.error("Dosya bulunamadı.", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 4000,
				html: true
			});
			e.target.value = null;
			return;
		}
	}

	async exportStockToExcelUnits() {
		let data = [];
		data.push({
			unit: "STOK BİRİMLERİ",
			unitCode: "STOK BİRİM KODU"
		});
		let params = {
			url: "/stock/getUnitCodes",
			method: "get"
		};
		await request(params)
			.then(function (response) {
				let unitCodes = response.data;
				for (let i = 0; i < unitCodes.length; i++) {
					let longCode = unitCodes[i].longCode;
					let shortCode = unitCodes[i].shortCode;
					data.push({
						unit: longCode,
						unitCode: shortCode
					});
				}
			}).catch(function (error) {
				showAxiosError(error);
			});

		return data;
	}

	bulkFileSelected(fileContent, self) {
		self.setState({processingExcel: true});
		let workbook = XLSX.read(fileContent, {type: "array"});
		let sheet = workbook.Sheets[workbook.SheetNames[0]];
		let range = XLSX.utils.decode_range(sheet["!ref"]);
		let despatchLines = [];
		for (let row = range.s.r; row <= range.e.r; row++) {
			if (row > 0) {
				let rowData = {};
				for (let col = range.s.c; col <= range.e.c; col++) {
					let cell = sheet[XLSX.utils.encode_cell({r: row, c: col})];
					if (cell) {
						rowData[DespatchLineEnum[col]] = cell.v;
					}
				}

				if (!(Object.keys(rowData).length === 0 && rowData.constructor === Object)) {
					let result = self.validateRowData(rowData, row);
					if (result.valid) {
						let despatchLine = self.rowToDespatchLine(rowData);
                        despatchLines.push(despatchLine);
					} else {
						Alert.error(result.message, {
							position: 'top-right',
							effect: 'stackslide',
							timeout: 4000,
							html: true
						});
						self.setState({processingExcel: false});
						return;
					}
				}
			}
		}

		for (let i = 0; i < despatchLines.length; i++) {
            despatchLines[i] = DespatchLines.calculate(despatchLines[i]);
		}
		if (despatchLines.length > 0) {
			self.setState({despatchLines});
			self.props.listener(despatchLines);
		} else {

		}
		self.setState({processingExcel: false});
	}

    validateRowData(rowData, row) {
		let message = "";
		let valid = true;
		if (rowData["itemName"] === undefined || rowData["itemName"] === '' || rowData["itemName"] === 'Boş Olamaz') {
			message = message + `${row}. Satırdaki Ürün Adı alanı boş olamaz.</br>`;
			valid = false;
		}
		if(this.props.profileId === "HKSIRSALIYE"){
			if (rowData["kunyeNo"] === undefined || rowData["kunyeNo"] === '' || rowData["kunyeNo"] === 'Boş Olamaz') {
				message = message + `${row}. Satırdaki Künye Numarası alanı boş olamaz.</br>`;
				valid = false;
			}
			if (rowData["kunyeNo"].toString().length !== 19 ) {
				message = message + `${row}. Satırdaki Künye Numarası alanı 19 karakterden oluşmalıdır.</br>`;
				valid = false;
			}
		}
		if (typeof rowData["quantity"] !== 'number') {
			message = message + `${row}. Satırdaki Miktar alanı sayısal bir değer olmalıdır.</br>`;
			valid = false;
		}
		if (!this.checkUnit(rowData["unit"])) {
			message = message + `${row}. Satırdaki Birim alanı formatı uygun değil.</br>`;
			valid = false;
		}
		if (typeof rowData["unitPrice"] !== 'number') {
			message = message + `${row}. Satırdaki Birim Fiyat alanı sayısal bir değer olmalıdır.</br>`;
			valid = false;
		}
		if ((rowData["innerItemCount"] !== undefined && rowData["innerItemCount"] !== "") && typeof rowData["innerItemCount"] !== 'number') {
			message = message + `${row}. Satırdaki İç Adet alanı sayısal bir değer olmalıdır.</br>`;
			valid = false;
		}
		if ((rowData["outstandingQuantity"] !== undefined && rowData["outstandingQuantity"] !== "")) {
			if (isNaN(rowData["outstandingQuantity"])) {
				message = message + `${row}. Satırdaki Sonradan gönderilecek miktar alanı sayısal bir değer olmalıdır.</br>`;
				valid = false;
			}
		}
		if ((rowData["barcode"] !== undefined && rowData["barcode"] !== "")){
			if (rowData["barcode"].toString().length !== 13) {
				message = message + `${row}. Satırdaki Barkod alanı 13 hane olmalıdır.</br>`;
				valid = false;
			}
		}
		return {valid: valid, message: message};
    }

    rowToDespatchLine(rowData) {
        return {
			recordId: null,
			itemName: rowData["itemName"],
			quantity: rowData["quantity"],
			unit: rowData["unit"],
			unitPrice: rowData["unitPrice"],
			kunyeNo: rowData["kunyeNo"] ? rowData["kunyeNo"] : null,
			innerItemCount: rowData["innerItemCount"],
			lineExplanation: rowData["lineExplanation"],
			outstandingQuantity: rowData["outstandingQuantity"],
			outstandingReason: rowData["outstandingReason"],
			buyersItemIdentification: rowData["buyersItemIdentification"],
			orderLineReference: rowData["orderLineReference"],
			barcode: rowData["barcode"],
			itemCode: null,
			itemId: null,
			lineExtensionAmount: null,
			note: null,
		}
	}

	async exportToExcel(e) {
		let despatchLines = deepCopyObject(this.state.despatchLines);
		let unitCodes = await this.exportStockToExcelUnits();

		let data = [];
		data.push({
			itemName: "Ürün Adı",
			quantity: "Miktar",
			unit: "Birim",
			unitPrice: "Birim Fiyat",
			kunyeNo: "Künye Numarası",
			innerItemCount: "İç Adet",
			outstandingQuantity: "Sonradan Gönderilecek Miktar",
			outstandingReason: "Sonradan Gönderilme Sebebi",
			buyersItemIdentification: "Müşteri Ürün Kodu",
			orderLineReference: "Sipariş No",
			barcode: "Barkod",
			lineExplanation: "Satır Açıklaması",
		})

		for (let i = 0; i < despatchLines.length; i++) {
			let line = despatchLines[i];

			let row = {
				itemName: (line["itemName"] !== "" && line["itemName"] !== null ? line["itemName"] : "Boş Olamaz"),
				quantity: line["quantity"],
				unit: line["unit"],
				unitPrice: line["unitPrice"],
				kunyeNo: line["kunyeNo"] ? line["kunyeNo"] : "",
				innerItemCount: (line["innerItemCount"] === 0 ||  line["innerItemCount"] === null) ? "" : line["innerItemCount"],
				outstandingQuantity: line["outstandingQuantity"] ? line["outstandingQuantity"] : "",
				outstandingReason: line["outstandingReason"] ? line["outstandingReason"] : "",
				buyersItemIdentification: line["buyersItemIdentification"] ?  line["buyersItemIdentification"] : "",
				orderLineReference: line["orderLineReference"] ?  line["orderLineReference"] : "",
				barcode: line["barcode"] ?  line["barcode"] : "",
				lineExplanation: line["lineExplanation"] ? line["lineExplanation"] : "",
			};

			data.push(row);
		}

		/* make the worksheet */
		let ws = XLSX.utils.json_to_sheet(data, {skipHeader: true});
		let ws2 = XLSX.utils.json_to_sheet(unitCodes, {skipHeader: true});

		/* add to workbook */
		let wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "Şablon");
		XLSX.utils.book_append_sheet(wb, ws2, "Stok Birimleri");

		/* generate an XLSX file */
		XLSX.writeFile(wb, "urun_hizmetler_" + moment().format("YYYY_mm_dd_HH_mm_ss") + ".xlsx");
	}

	checkUnit(unit) {
		if (typeof unit !== 'string' || unit === '') {
			return false;
		}
		return true;
	}

	onInputChange(e, label, index){
		let despatchLines = deepCopyObject(this.state.despatchLines);
		if(!!e.target.value){
			despatchLines[index][label] = e.target.value;
			this.props.listener(despatchLines);
			this.setState({despatchLines});
		}
	}

	  onInputKeyDown(e, index){
		if(e.keyCode === 9){
			if(!!e.target.value){
				let despatchLines = deepCopyObject(this.state.despatchLines);
				despatchLines[index]["itemName"] = e.target.value;
				this.props.listener(despatchLines);
				this.setState({despatchLines});
			}
			window.setTimeout(function () {
				document.getElementById("quantity_" + index).focus();
				const quantityInput = document.getElementById("quantity_" + index);
				quantityInput.focus();
				quantityInput.select();
			}, 0);
		}
	}


	render() {
		return (
			<div className="">

				<div className="card-header  row" style={{margin:'0px auto'}}>
					<div className="col-sm-3">
						<h4 className="card-title ">Ürün Hizmet Bilgileri</h4>
					</div>
					<div className="col-sm-9" style={{float: 'right'}}>
						<input ref={this.inputFile}
							   type="file" accept=".xlsx,.xls" multiple={false}
							   style={{
								   display: 'block',
								   visibility: 'hidden',
								   width: '0px',
								   height: '0px'
							   }}
							   onChange={this.handleUploadExcel}/>
						<div className="">
						<button type="button"
								className="TekBtn ekle hizala  btn-md" style={{
							float: 'right', marginTop: '0px', padding: '10px 39px 10px 16px', marginRight: '-15px', marginLeft: '5px'}}
								onClick={this.addDespatchLine}>Satır Ekle
						</button>
						</div>
						<div className="" style={{float: 'right'}}>
						<button className="MenuBtn2 listt"
								style={{
									float: 'right',
									marginLeft: '7px',
									padding: '10px 43px 9px 13px',
									marginTop: '0px',
								}}
								type="button"
								id="dropdownMenuButton"
								data-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false">
							Excel
						</button>

						<div className="dropdown-menu">
							<a className="dropdown-item"
							   onClick={() => this.inputFile && this.inputFile.current && this.inputFile.current.click()}><i
								className="fa fa-file-excel-o"/> Excel'den Yükle</a>
							<a className="dropdown-item"
							   onClick={this.exportToExcel}><i
								className="fas fa-external-link-alt"/> Excel'e
								Aktar</a>
							<a className="dropdown-item"
							   onClick={this.exportToExcel}><i className="fa fa-download"/> Örnek
								Excel
								İndir</a>
						</div>
						</div>
					</div>

				</div>
				<div className="card-body">
					<div className="row">
						<div className="col-sm-12 " style={{ paddingLeft:'0px', paddingRight:'10px'}}>
							<table className="" style={{textAlign: 'center'}}>
								<thead>
								<tr style={{backgroundColor: '#ebedf0'}}>
									<th width="2%">#</th>
									<th width="15%" id={"itemName"}>Ürün
										<i className="fa fa-question-circle"
												 style={{float: 'right'}} aria-hidden="true"/>
											<UncontrolledTooltip placement="right" target={"itemName"}
																 delay={0}>Yazılan ürünü stoğa kaydetmek istemiyorsanız TAB tuşuna veya Fare ile boş bir alana tıklayabilirsiniz.</UncontrolledTooltip>
									</th>
									<th width="8%">Miktar</th>
									<th width="8%">Birim</th>
									<th width="8%">Birim Fiyat</th>
									{this.props.profileId === 'HKSIRSALIYE' && <th>Künye Numarası</th>}
									<th>Sonradan Gönderilecek Miktar</th>
									<th>Sonradan Gönderilme Sebebi</th>
									<th>Ürün Tutarı</th>
									<th width="2%">İşlemler</th>
								</tr>
								</thead>
								<tbody>
								{this.state.despatchLines &&
								this.state.despatchLines.map((despatchLine, index) =>
									<tr key={index}>
										<td>{index + 1}</td>
										<td className={"form-group" + this.validateClass('itemName_' + index)}>
											<Select.AsyncCreatable
												multi={false}
												ignoreAccents={false}
												id={'itemName_' + index}
												value={{
													value: despatchLine.itemName,
													label: despatchLine.itemName
												}}
												onChange={(e) => this.onStockChange(e, index)}
												onBlur={(e)=> this.onInputChange(e, 'itemName', index)}
												isLoading={true}
												autoload={false}
												cache={false}
												clearable={false}
												noResultsText="Kayıt bulunamadı."
												searchPromptText="Arama için en az 3 karakter giriniz."
												placeholder="Stok Adı ile ara..."
												loadingPlaceholder="Yükleniyor..."
												onNewOptionClick={(option) => this.createStock(option, index)}
												filterOptions={(options, filter, currentValues)=> filterOptions(options, filter, currentValues)}
												promptTextCreator={(label) => "Stoğa Ekle" }
												showNewOptionAtTop={false}
												arrowRenderer={this.arrowRenderer}
												onBlurResetsInput={false}
												onInputKeyDown={(e) => this.onInputKeyDown(e, index)}
												onCloseResetsInput={false}
												loadOptions={getStocks}/>
											{this.validateMessage('itemName_' + index) !== "" &&
											<UncontrolledTooltip placement="right" target={'itemName_' + index}
																 delay={0}>
												{this.validateMessage('itemName_' + index)}
											</UncontrolledTooltip>}
										</td>
										<td>
											<NumberFormat id={'quantity_' + index}
														  value={despatchLine.quantity}
														  allowNegative={false}
														  isNumericString={true}
														  allowEmptyFormatting={false}
														  decimalScale={9}
														  thousandSeparator={'.'}
														  decimalSeparator={','}
														  displayType="input"
														  placeholder=""
														  renderText={value => {
															  value.replace(/\./g, ',')
														  }}
														  onValueChange={(e) => this.onValueChange(e, 'quantity', index)}
														  className="form-control"/>
										</td>
										<td>
											<Select
												id={'unit_' + index}
												placeholder="Birim Seçiniz"
												value={despatchLine.unit}
												clearable={false}
												style={{ width: "100%"}}
												noResultsText="Sonuç yok"
												onChange={(e) => e && this.onChange({target:{value:e.value}},"unit", index)}
												options={this.state.unitCodes.map(unitCode => ({
													value: unitCode.shortCode,
													label: unitCode.longCode
												}))}
											/>
										</td>
										<td>
											<NumberFormat id={'unitPrice_' + index}
														  value={(despatchLine.unitPrice==="0" || despatchLine.unitPrice===0) ? "" : despatchLine.unitPrice}
														  allowNegative={false}
														  isNumericString={true}
														  allowEmptyFormatting={false}
														  decimalScale={9}
														  thousandSeparator={'.'}
														  decimalSeparator={','}
														  displayType="input"
														  /*isAllowed={values => {
															  return (values.value === "" ? false : true);
														  }}*/
														  placeholder=""
														  renderText={value => {
															  value.replace(/\./g, ',')
														  }}
														  onValueChange={(e) => this.onValueChange(e, 'unitPrice', index)}
														  className="form-control"/>
										</td>
										{this.props.profileId === 'HKSIRSALIYE' &&
											<td>
												<NumberFormat id={'kunyeNo_' + index}
															  value={despatchLine.kunyeNo}
															  allowNegative={false}
															  isNumericString={true}
															  allowEmptyFormatting={false}
															  data-vlength="19,19"
															  maxLength={19}
															  displayType="input"
															  onBlur={this.validateField}
															  holder="Künye Numarası"
															  onValueChange={(e) => this.onValueChange(e, 'kunyeNo', index)}
															  className="form-control"/>
												{this.validateMessage('kunyeNo_' + index) !== "" &&
												<UncontrolledTooltip placement="right" target={'kunyeNo_' + index}
																	 delay={0}>
													{this.validateMessage('kunyeNo_' + index)}
												</UncontrolledTooltip>}
											</td>}
										<td>
											<NumberFormat id={'outstandingQuantity_' + index}
														  value={despatchLine.outstandingQuantity || ""}
														  allowNegative={false}
														  isNumericString={true}
														  allowEmptyFormatting={false}
														  decimalScale={9}
														  thousandSeparator={'.'}
														  decimalSeparator={','}
														  displayType="input"
														  isAllowed={values => {
															  return (values.value !== "");
														  }}
														  placeholder=""
														  renderText={value => {
															  value.replace(/\./g, ',')
														  }}
														  onValueChange={(e) => this.onValueChange(e, 'outstandingQuantity', index)}
														  className="form-control"/>
										</td>
										<td className={"form-group" + this.validateClass('outstandingReason_' + index)}>
											<input id={'outstandingReason_' + index}
												   type="text"
												   className="form-control"
												   placeholder=""
												   value={despatchLine.outstandingReason}
												   onChange={(e) => this.onChange(e, 'outstandingReason', index)}/>
											{this.validateMessage('outstandingReason_' + index) !== "" &&
											<UncontrolledTooltip placement="right"
																 target={"outstandingReason_" + index} delay={0}>
												{this.validateMessage("outstandingReason_" + index)}
											</UncontrolledTooltip>}
										</td>
										<td>
											<NumberFormat id={'lineExtensionAmount_' + index}
														  value={despatchLine.lineExtensionAmount}
														  allowNegative={false}
														  isNumericString={true}
														  disabled={true}
														  thousandSeparator={'.'}
														  decimalSeparator={','}
														  suffix={this.props.suffix}
														  displayType="input"
														  isAllowed={values => {
															  return (values.value === "" ? false : true);
														  }}
														  placeholder=""
														  renderText={value => {
															  value.replace(/\./g, ',')
														  }}
														  onValueChange={(e) => this.onValueChange(e, 'lineExtensionAmount', index)}
														  className="form-control"/>
										</td>
										<td>
											<button type="button"
													className={"Btn edit " + " btn-primary"}
													style={{background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}
													onClick={() => this.editDespatchLine(index)}></button>
											{this.state.despatchLines.length > 1  &&
											<button type="button"
													className="Btn temizle" style={{margin: "0", background:'#FFCCCC'}}
													onClick={() => this.removeDespatchLine(index)}>
											</button>
											}
										</td>
									</tr>
								)
								}
								</tbody>
							</table>
						</div>
						{this.state.stockModal &&
						<StockModal listener={this.setStocks}
									modal={this.state.stockModal}
									stock={this.state.stock}
									isCreate={this.state.isCreate}
									currencyCodes={this.props.currencyCodes}
									unitCodes={this.props.unitCodes}
									exemptions={[]}
									source="despatchLines"
						/>
						}
						{this.state.despatchLineModal &&
						<DespatchLineModal
							listener={this.setDespatchLine}
							modal={this.state.despatchLineModal}
							toggle={()=>{this.setState({despatchLineModal:!this.state.despatchLineModal})}}
							index={this.state.index}
							despatchLine={this.state.despatchLines[this.state.index]}
							unitCodes={this.props.unitCodes}
						/>
						}

					</div>
				</div>
			</div>
		);
	}
}

export default DespatchLines;

